export default __webpack_public_path__ + "dist/media/landing.0c2e4d25.png";